import { useTranslation } from "react-i18next";

const currentYear = new Date().getFullYear();

interface CopyrightProps {
  className?: string;
}

export function Copyright({ className }: CopyrightProps) {
  const { t } = useTranslation();

  return (
    <p className={className}>{t("common.copyright", { year: currentYear })}</p>
  );
}
